import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../../engine/design/primitives/Button';
import { QuickLog } from '../../components/QuickLog';
import { useDataSource } from '../../engine/meta/useDataSource';

// The timesheets list's primary action: "Log time" opens the quick-log dialog. Timesheets
// are period buckets, so there is no "New timesheet" — the bucket appears when time lands.
// `?log=1` (palette / dashboard shortcut) opens it on arrival.

export function LogTimeAction() {
  const [params, setParams] = useSearchParams();
  const [open, setOpen] = useState(() => params.has('log'));
  // Quick-log writes NovaPSA time entries: on a connected system that does not serve them (Halo,
  // where time is logged on the ticket) the timesheets stay read-only here.
  const served = useDataSource().resourceServed('time-entries');
  const close = () => {
    setOpen(false);
    if (params.has('log')) {
      const next = new URLSearchParams(params);
      next.delete('log');
      setParams(next, { replace: true });
    }
  };
  if (!served) return null;
  return (
    <>
      <Button variant="primary" icon="timer" onClick={() => setOpen(true)}>
        Log time
      </Button>
      <QuickLog open={open} onClose={close} />
    </>
  );
}
